<div class="body">
    <div class="container">
        <div class="row mt-5">
            <div class="col-md-4 mx-auto">
                <div class="card">
                    <div class="card-header">
                        <h5 class="card-title">Rastrear Carga</h5>
                      </div>
                    <div class="card-body">
                       <form method="POST" #fRecommend="ngForm" [formGroup]="sendForm" enctype="application / x-www-form-urlencoded">
                        <div class="my-1">
                            <label class="sr-only" for="idSearch">ID DE REGISTRO</label>
                            <div class="input-group">
                              <div class="input-group-prepend">
                                <div class="input-group-text"><i class="fas fa-search-location"></i></div>
                              </div>
                              <input type="text" class="form-control" [ngClass]="{ 'is-invalid': fRecommend.submitted && sendForm.controls.id.errors }"  formControlName="id" id="idSearch" name="id" placeholder="ID DE RASTREO">
                            </div>
                          </div>
                            <div class="g-recaptcha-wrapper my-4">
                              <re-captcha #captchaRef="reCaptcha" (resolved)="resolved($event)" siteKey="{{SITE_KEY}}"></re-captcha>
                              <div id="topHider"></div>
                              <div id="rightHider"></div>
                              <div id="bottomHider"></div>
                              <div id="leftHider"></div>
                            </div>
                          <div class="container px-4">
                                <div class="row d-flex justify-content-center">
                                  <button type="submit" id="search" class="btn btn-outline-primary  col-md-6" (click) = "search($event)">Buscar</button>
                                  <button type="submit" id="edit" class="btn btn-outline-secondary col-md-6" *ngIf="(isLogin |async)" (click) = "edit($event)">Modificar</button>
                                 </div>
                          </div>
                       </form>

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
